export default __webpack_public_path__ + "static/media/widget3-img2.d504bd09.jfif";